export default function RegisterForm({ setEmail, setPassword, handleRegister, setIsActive }) {
    return (
        <div className="form-box register">
            <h2>Registration</h2>
            <form onSubmit={handleRegister}>
                <div className="input-box">
                <span className="icon"><ion-icon name="person"></ion-icon></span>
                <input type="text" required />
                <label>Username</label>
                </div>
                <div className="input-box">
                <span className="icon"><ion-icon name="mail"></ion-icon></span>
                <input type="email" required onChange={(e) => setEmail(e.target.value)} />
                <label>Email</label>
                </div>
                <div className="input-box">
                <span className="icon"><ion-icon name="lock-closed"></ion-icon></span>
                <input type="password" required onChange={(e) => setPassword(e.target.value)} />
                <label>Password</label>
                </div>
                <div className="remember-forgot">
                <label><input type="checkbox" required /> I agree to the terms & conditions</label>
                </div>
                <button type="submit" className="btn">Register</button>
                <div className="login-register">
                <p>Already have an account? <a href="#" className="login-link" onClick={() => setIsActive(false)}>Login</a></p>
                </div>
            </form>
        </div>
    );
}